var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[this.isViewMode ? 'card-link-text' : 'card-link-text-disable'],attrs:{"role":"link"},on:{"click":function($event){$event.stopPropagation();return _vm.openDocument.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }